export const GAME_H = 1080;
export const MIN_ASPECT = 4 / 3;
export const MAX_ASPECT = 21 / 9;

export const PX_PER_M = 64;

export const PLAYER_SCREEN_Y = 0.3;
export const ZOOM_MAX = 1.0;
export const ZOOM_MIN = 0.4;
export const TOUCH_ZOOM = 0.85;

export const CHUNK_W_M = 40;
export const CHUNK_H_M = 50;
export const ORIGIN_SHIFT_AT = 400_000;
export const TRANSITION_M = 75;

export const LAYERS = ["ground", "world", "overhead", "ui"];
export const DEFAULT_LAYER = "world";

export const COLORS = {
    meadow: "#7cb342",
    forest: "#4e6b3a",
    ui: "#2b2b2b",
    uiText: "#fff8e7",
    debug: "#ff00ff",
};
